import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './schedule_appointment_modal.scss';

function Disclaimer({
  syncCardData,
  phone,
  merchant,
  holdsOrDepositsEnabled,
  practiceName,
  surchargingEnabled,
  surchargingMaxRate,
}) {
  const [ccAgree, setAgree] = useState(false);
  const { t } = useTranslation();

  function handleAgreeChange() {
    setAgree(!ccAgree);
    syncCardData({
      ccAgree: !ccAgree,
    });
  }

  if (merchant === 'stripe') {
    if (!holdsOrDepositsEnabled || !surchargingEnabled) {
      return null;
    }

    const surchargingPercentage =
      typeof surchargingMaxRate === 'number' && surchargingMaxRate > 0
        ? `${(surchargingMaxRate * 100).toFixed(2).replace(/\.?0+$/, '')}%`
        : null;

    return (
      <div className="surcharge-compliance-banner">
        <p>
          {surchargingPercentage
            ? t(
                '{{practiceName}} assesses a surcharge of {{surchargingPercentage}} on eligible credit card transactions, which is not greater than our cost of accepting the card. Payment by credit card is not mandatory. We also accept other forms of payment without applying a surcharge such as debit cards.',
                { practiceName, surchargingPercentage },
              )
            : t(
                '{{practiceName}} assesses a surcharge on eligible credit card transactions, which is not greater than our cost of accepting the card. Payment by credit card is not mandatory. We also accept other forms of payment without applying a surcharge such as debit cards.',
                { practiceName },
              )}
        </p>
      </div>
    );
  }

  return (
    <div>
      <form id="paymentForm">
        <div>
          <p>
            {t(
              'By entering your credit card information, you are giving permission to our dental practice to securely store your credit card information on file.',
            )}
          </p>
          <p>
            {t('If you have any questions, please call our practice at')} {phone}.
          </p>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            onChange={handleAgreeChange}
            id="defaultCheck1"
            required
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {t('I understand')}
          </label>
        </div>
      </form>
    </div>
  );
}

Disclaimer.propTypes = {
  syncCardData: PropTypes.func,
  phone: PropTypes.string,
  merchant: PropTypes.string,
  holdsOrDepositsEnabled: PropTypes.bool,
  practiceName: PropTypes.string,
  surchargingEnabled: PropTypes.bool,
  surchargingMaxRate: PropTypes.number,
};

export default Disclaimer;
